import { Heading } from '@findy-code/yuffie/ui/heading';
import { Stack } from '@findy-code/yuffie/ui/stack';

import styles from './company-detail-skills.component.module.scss';
import { SectionLayout } from './section-layout.component';

type SkillType = {
  id: number;
  skillType?: string | null;
  skill: {
    name: string;
  };
};

type Props = {
  skills: SkillType[];
};

export const CompanyDetailSkills = ({ skills }: Props) => {
  const languages = skills.filter((skill) => skill.skillType === 'lang');
  const frameworks = skills.filter((skill) => skill.skillType === 'framework');
  const infrastructures = skills.filter(
    (skill) => skill.skillType === 'infra_middleware'
  );
  const devTools = skills.filter((skill) => skill.skillType === 'dev_tool');

  return (
    <SectionLayout heading={{ title: '利用技術' }} id="skills">
      <div className={styles.stackBlock}>
        <Stack
          align={{ base: 'start', md: 'center' }}
          as="section"
          className={styles.stackItem}
          direction={{ base: 'column', md: 'row' }}
          justify="start"
          spacing={{ base: 'xxs', md: 'xxl' }}
          wrap="nowrap"
        >
          <Heading as="h3" className={styles.stackTitle} font="heading-xs">
            言語
          </Heading>
          <ul className={styles.stackList}>
            {languages.map((language) => (
              <li className={styles.stackListItem} key={language.id}>
                {language.skill.name}
              </li>
            ))}
          </ul>
        </Stack>
        <Stack
          align={{ base: 'start', md: 'center' }}
          as="section"
          className={styles.stackItem}
          direction={{ base: 'column', md: 'row' }}
          justify="start"
          spacing={{ base: 'xxs', md: 'xxl' }}
          wrap="nowrap"
        >
          <Heading as="h3" className={styles.stackTitle} font="heading-xs">
            フレームワーク
          </Heading>
          <ul className={styles.stackList}>
            {frameworks.map((framework) => (
              <li className={styles.stackListItem} key={framework.id}>
                {framework.skill.name}
              </li>
            ))}
          </ul>
        </Stack>
        <Stack
          align={{ base: 'start', md: 'center' }}
          as="section"
          className={styles.stackItem}
          direction={{ base: 'column', md: 'row' }}
          justify="start"
          spacing={{ base: 'xxs', md: 'xxl' }}
          wrap="nowrap"
        >
          <Heading as="h3" className={styles.stackTitle} font="heading-xs">
            インフラ・ミドルウェア
          </Heading>
          <ul className={styles.stackList}>
            {infrastructures.map((infrastructure) => (
              <li className={styles.stackListItem} key={infrastructure.id}>
                {infrastructure.skill.name}
              </li>
            ))}
          </ul>
        </Stack>
        <Stack
          align={{ base: 'start', md: 'center' }}
          as="section"
          className={styles.stackItem}
          direction={{ base: 'column', md: 'row' }}
          justify="start"
          spacing={{ base: 'xxs', md: 'xxl' }}
          wrap="nowrap"
        >
          <Heading as="h3" className={styles.stackTitle} font="heading-xs">
            開発ツール
          </Heading>
          <ul className={styles.stackList}>
            {devTools.map((devTool) => (
              <li className={styles.stackListItem} key={devTool.id}>
                {devTool.skill.name}
              </li>
            ))}
          </ul>
        </Stack>
      </div>
    </SectionLayout>
  );
};
